import Flexbox from "$/components/ui/Flexbox";

export const inputClassname =
  "!rounded-[100px] !px-1.5 !py-2 w-full [&>input]:leading-3 bg-gray-inputBg";

const InputsStyling = () => {
  return <Flexbox className="relative min-h-[150dvh]">Text</Flexbox>;
};

export default InputsStyling;
